import { render, staticRenderFns } from "./SpotFolderFile.vue?vue&type=template&id=0ab7bb40&"
import script from "./SpotFolderFile.vue?vue&type=script&lang=js&"
export * from "./SpotFolderFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports